import { render, staticRenderFns } from "./AddStockPrice.vue?vue&type=template&id=42f0a53b"
import script from "./AddStockPrice.vue?vue&type=script&lang=js"
export * from "./AddStockPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports